  import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
  import RestEndPoint from '../../../common/RestEndPoint';
  
  export default class LeaseMasterChangeService {
    static GetPriceChanges(data) {
      return RestEndPoint.callAzureFunction(
        APIUrlConstants.GetPriceChanges,
        'POST',
        AppConstants.APP_BACKEND_HOST_KEY,   
        data
      );
    }

    static GetMarketingRepList() {
      return RestEndPoint.callAzureFunction(
        APIUrlConstants.GetMarketingRepList,
        'GET',
        AppConstants.APP_BACKEND_HOST_KEY
      );
    }

    static ResetUserProfile(data) {
      return RestEndPoint.callAzureFunction(
        APIUrlConstants.ResetUserProfile, 
        'DELETE',
        AppConstants.APP_BACKEND_HOST_KEY,
        data
      );
    }

    static GetUserProfile(data) {
      return RestEndPoint.callAzureFunction(
        APIUrlConstants.GetUserProfile, 
        'POST',
        AppConstants.APP_BACKEND_HOST_KEY,
        data
      );
    }

    static SaveUserProfile(data) {
      return RestEndPoint.callAzureFunction(
        APIUrlConstants.SaveUserProfile, 
        'POST',
        AppConstants.APP_BACKEND_HOST_KEY,
        data
      );
    }
  }